import Default from './default.js';

export default class Factory {
    constructor(baseFactory) {
        this.baseFactory = baseFactory;
    }
    default() {
        new Default(this.baseFactory);
        return this;
    }
}
